var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 410 410",
    style: {
      enableBackground: "new 0 0 410 410"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_995_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_996_",
    style: {
      fill: "#DEDDE0"
    },
    points: "125,340 125,310 205,310 205,280 125,280 125,250 205,250 205,220 125,220  125,190 205,190 205,160 125,160 125,130 205,130 205,100 205,70 205,0 125,0 125,70 56.707,70 55,71.75 55,410 205,410 205,340  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_997_",
    style: {
      fill: "#CDCDD0"
    },
    points: "205,0 205,70 285,70 285,100 205,100 205,130 285,130 285,160 205,160  205,190 285,190 285,220 205,220 205,250 285,250 285,280 205,280 205,310 205,340 205,410 355,410 355,0  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_998_",
    x: 205,
    y: 70,
    style: {
      fill: "#FFFFFF"
    },
    width: 80,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_999_",
    x: 125,
    y: 310,
    style: {
      fill: "#FFFFFF"
    },
    width: 80,
    height: 30
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1000_",
    style: {
      fill: "#FFFFFF"
    },
    points: "125,160 205,160 285,160 285,130 205,130 125,130  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1001_",
    style: {
      fill: "#FFFFFF"
    },
    points: "125,220 205,220 285,220 285,190 205,190 125,190  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1002_",
    style: {
      fill: "#FFFFFF"
    },
    points: "125,280 205,280 285,280 285,250 205,250 125,250  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1003_",
    style: {
      fill: "#ACABB1"
    },
    points: "125,0 55,70 56.707,70 125,70  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ecdc440ecd4be729a89abda9230f6ead.svg";
export { ForwardRef as ReactComponent };